import apiServices from "../../ApiServices/request-handler";
import { downloadBase64File, requestHandler } from "../../utils/functions";
import { setApplicationId } from "../slices/contentSlice";
import { setCorporateDropdownData, setCorporateKycData, setCorporateLoading, setCorporateSaveLoading, setDeleteDraftKycLoading, setFieldCodes, setFieldCodesLoading, setIsQualified, setIsRejected, setRejectionSummary, setUploadLoading } from "../slices/corporate-slice";

export const getCorporateDropdowns = (id) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getCorporateDropdowns,
                param_data: id,
                setData: setCorporateDropdownData,
            }),
        );
    };
};

export const getCorporateKycData = (id) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getCorporateKycData,
                param_data: id,
                setData: setCorporateKycData,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    const client_classification = data?.result?.kycClientClassification?.clientClassification;
                    dispatch(setIsQualified(client_classification === 1070));
                }
            }),
        );
    };
};

export const saveCorporateKycData = (data, onDone, onError, isLoading = true) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.saveCorporateKycData,
                param_data: data,
                setLoading: isLoading ? setCorporateSaveLoading : null,
                onDone: (data) => onDone?.(),
                isSuccessMessage: true,
                onError,
            }),
        );
    };
};

export const submitCorporateKyc = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.submitCorporateKyc,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => onDone?.(),
                isSuccessMessage: true,
            }),
        );
    };
};

export const initiateCorporateKyc = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.initiateCorporateKyc,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    dispatch(setApplicationId(data?.result?.applicationId));
                    onDone?.(data?.result);
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const uploadKycDocument = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.uploadKycDocument,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    onDone?.();
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const deleteKycDocument = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.deleteKycDocument,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    onDone?.();
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const downloadKycDocument = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.downloadKycDocument,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: async (response) => {
                    downloadBase64File({ base64Data: response?.result?.payload, fileName: response?.result?.fileName, type: response?.result?.mimeType });
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const submitKycForm = (data, onDone, onError) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.submitKycForm,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: async (response) => {
                    onDone?.();
                },
                isSuccessMessage: true,
                onError,
            }),
        );
    };
};

export const getRejectionSummary = (id, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getRejectionSummary,
                param_data: id,
                setData: setRejectionSummary,
                onDone: async (response) => {
                    response?.result?.length > 0 ?
                        dispatch(setIsRejected(true)) :
                        dispatch(setIsRejected(false));
                    onDone?.(response);
                },
                onError: () => {
                    dispatch(setIsRejected(false));
                    dispatch(setRejectionSummary(null));
                },
                isErrorMessage: false,
            }),
        );
    };
};

export const getFieldCodes = (onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getFieldCodes,
                setData: setFieldCodes,
                setLoading: setFieldCodesLoading,
                onDone: async (response) => {
                    onDone?.();
                },
                isSuccessMessage: false,
            }),
        );
    };
};

export const getDocument = (onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.fetchDocument,
                setLoading: setUploadLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    };
}

export const deleteDraftKyc = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.deleteDraftKyc,
                param_data: data,
                setLoading: setDeleteDraftKycLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    };
}

export const validateIbanKyc = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.validateIbanKyc,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (response) => {
                    onDone?.(response);
                },
            }),
        );
    };
};